var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',[_c('select-type',{attrs:{"label":'Język',"name":'languageSelect',"options":_vm.languages},model:{value:(_vm.value['locale']),callback:function ($$v) {_vm.$set(_vm.value, 'locale', $$v)},expression:"value['locale']"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }